
import React, { Component } from 'react';
import TableSessionHelper from '../../../../../Model/TableSession';
import MessageModal from '../../../../../jsx/modal/MessageModal';
import ReactHelper from '../../../../../util/ReactHelper';
import BillRepository from '../../../../repository/BillRepository';
import { BillStatus } from '../../../../../Model/Bill';
import { TableSessionType } from '../../../../../app/Common/Enum/TableSessionType';
import TemporaryTableQrRepository from '../../../../repository/TemporaryTableQrRepository';


class SelectTableSession extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bills: {},
            tempTableQrs: [],
        }

        // Source of truth for this.state.bills to handle setState() race condition
        this.bills = {}

        // To prevent loading same bill multiple times
        this.billsLoaded = {}
        this.callbackKey = "SelectTableSession"
    }
    componentDidMount = () => {
        this.loadBills()
        this.loadTemporaryTableQr()
    }
    componentWillUnmount() {
        BillRepository.getInstance().removeCallback(null, this)
    }
    componentDidUpdate(prevState, prevProps) {
        ReactHelper.handleComponentDidUpdate(this, ["sessions", "orders"], () => {
            this.loadBills()
        })
        ReactHelper.handleComponentDidUpdate(this, ["sessions", "tempSessions"], () => {
            this.updateDropdownList()
        })
    }
    loadTemporaryTableQr = () => {
        TemporaryTableQrRepository.getInstance().loadAll(tempTableQrs => {
            this.setState({tempTableQrs}, this.updateDropdownList)
        }, this.callbackKey, this)
    }
    loadBills = () => {
        this.getTableSessions().forEach(ts => {
            if (ts.bill_id) {
                if (!this.billsLoaded[ts.bill_id]) {
                    this.billsLoaded[ts.bill_id] = true // Do not duplicate load
                    BillRepository.getInstance().loadOne(ts.bill_id, (bill) => {
                        let bills = {...this.bills}
                        bills[ts.bill_id] = bill
                        this.bills = bills

                        // Throttle to prevent excessive UI update
                        this.billTimer = setTimeout(() => {
                            this.setState({bills: this.bills})
                        }, 200)
                    }, this.callbackKey, this)
                }
            }
        })
    }
    getTableSessions = () => {
        let tableSessions = TableSessionHelper.getSessionsForTableWithActiveOrders({id:this.props.tableId})
        if (this.state.tempTableQrs && this.state.tempTableQrs.length) {
            tableSessions = [...tableSessions]
            this.state.tempTableQrs.forEach(ttqr => {
                if (ttqr.table_id == this.props.tableId) {
                    let a = TableSessionHelper.find(ttqr.table_session_id)
                    if (a && tableSessions.find(ts => ts.id == a.id) == null) {
                        // Check for duplicate before add
                        tableSessions.push(a)
                    }
                }
            })
        }
        if (TableSessionHelper.getFilter()) {
            tableSessions = tableSessions.filter(TableSessionHelper.getFilter())
        }
        return tableSessions
    }
    getTempSessions = () => {
        return AppData.data.state.tempSessions.filter( session => session.table_id == this.props.tableId )
    }
    getOrders = () => {
        return AppData.state.adminOrders.filter(order => this.props.app.state.currentSession && order.table_session_id == this.props.app.state.currentSession.id )
    }
    removeCurrentTempSession = () => {
        const tableSessionCount = this.getTableSessions().length
        const tempTableSessionCount = this.getTempSessions().length
        if (tableSessionCount == 0 && tempTableSessionCount < 2) {
            const showMessage = lang.cannot_remove_ticket
            this.setState({showMessage})
            return
        }
        let {tempSessions, currentSession} = AppData.data.state
        let index = tempSessions.findIndex(session => session.id == currentSession.id)
        tempSessions.splice(index,1)
        tempSessions = [...tempSessions]    // To trigger render

        // After delete, point current session to
        // 1. first actual table session, or if not exist then
        // 2. first dummy session
        if (tableSessionCount > 0 ) {
            currentSession = this.getTableSessions()[0]
        }
        else {
            currentSession = this.getTempSessions()[0]
        }
        AppData.data.setState({tempSessions, currentSession})
    }
    onSortByClicked = () =>{
        let result = !AppData.data.state.sort_by
        let value = result? "true" : "false"
        localStorage.setItem("admin_order_sortby", value)

        AppData.data.setState({
            sort_by: result,
        });
    }
    onClearAllDraftOrdersClicked = (tableSesionId) => {
        this.props.onClearAllDraftOrdersClicked && this.props.onClearAllDraftOrdersClicked(tableSesionId)
    }

    isDineInPaid = (tableSession) => {
        if (tableSession.bill_id && [TableSessionType.DINE_IN, TableSessionType.DINE_IN_WITH_PAYMENT].indexOf(parseInt(tableSession.table_session_type_id)) !== -1) {
            let bill = this.state.bills[tableSession.bill_id]
            if (bill && bill.status == BillStatus.CLOSED) {
                return true
            }
        }
        return false
    }
    updateDropdownList = () => {
        let ticketIndex = 1;
        let tableSessions = this.getTableSessions()
        tableSessions.sort((a,b) => {
            let bQueue = b.queue_number || 0
            let aQueue = a.queue_number || 0
            if (aQueue && bQueue) {
                // Both exist, sort ascending
                return aQueue - bQueue
            }
            else {
                // One non-exist, or both non exist
                return bQueue - aQueue
            }
        })
        let debugMode = window.debugSetting && window.debugSetting.admin_order && window.debugSetting.admin_order.debug_mode
        let options = tableSessions.map( session => {
            let ticketNumber = `${lang.ticket} ${ticketIndex++}`
            let paidTxt = ""
            if (session.queue_number) {
                ticketNumber = session.queue_number
            }
            if (this.isDineInPaid(session)) {
                paidTxt = ` (${lang.paid})`
            }
            return <option key={session.id} value={session.id}>{ticketNumber}{paidTxt}{debugMode ? `(ID: ${session.id})` : ""}</option>
        })

        this.getTempSessions().map(session => {
            options.push(<option key={session.id} value={session.id}>* {lang.ticket} {ticketIndex++}</option>)
        })
        options.push(<option key="-1" value="-1">{lang.new_ticket}</option>)

        this.setState({options})
    }
    render() {
        let options = this.state.options || []

        //calculate ticket length
        let length = this.getTableSessions().length
        let isShow = true
        if(length < 2){
            isShow = false
        }

        let adminOrderSortByDesc = AppData.data.state.sort_by
        let className = "fa fa-arrow-up"
        if(!adminOrderSortByDesc){
            className = "fa fa-arrow-down"
        }

        const currentSessionId = (AppData.data.state.currentSession && AppData.data.state.currentSession.id) || "-1"
        return (
            <>
                <select className="btn btn-warning" value={currentSessionId} onChange={this.props.onSelectTableSessionClicked}>
                    {options}
                </select>

                {currentSessionId < 0 && <span onClick={this.removeCurrentTempSession}><i className="fa fa-trash ml-2 text-danger"></i></span>}

                <div style={{float:"right"}}>
                    <div style={{display: "flex", gap: "5px"}}>
                        {
                            this.props.membershipBtn && this.props.membershipBtn()
                        }
                        <button className="btn btn-warning" onClick={() => this.onClearAllDraftOrdersClicked(currentSessionId)}>
                            {lang.clear_all_draft_order}
                        </button>
                        <button  className="btn btn-default" onClick={this.onSortByClicked}>
                            <i className={className + " text-danger"} style={{ color: "#636b6f", display: "block"}}></i>
                        </button>
                    </div>
                </div>

                {isShow &&  <span className="item-font" style={{float:"right", display:"inline-flex", alignItems:"center", minHeight:"30px", fontWeight:"bold", color:"darkgoldenrod"}}>{lang.ticket_no + ": " + length}</span>}
                {this.state.showMessage && <MessageModal message={this.state.showMessage} onClose={() => this.setState({showMessage: null})}/> }
            </>
        );
    }
}

export default SelectTableSession;